// Разметка блюда в меню
import React from 'react';
import './MenuDish.css'
import { useSelector, useDispatch } from 'react-redux'
import { getRecipeId } from '../../../store/api.js' 
import { Preloader } from '../../organisms'
import { Link } from 'react-router-dom' 

export function MenuDish (props) {
  const {recipes} = useSelector(state => state.recipes) 
  const {statusPlan} = useSelector(state => state.plans)
  const id= props.item 
  let recipe = recipes.find(i => i._id === id)
  const [click, setClick] = React.useState(false) //Отслеживание клика для вывода прелоудера в меню
  const [recipeSerch, setRecipeSerch] = React.useState()
 
  React.useEffect(()=> {
    if(statusPlan === 'resolved') {
      setClick(false)
    }
  }, [statusPlan]) 
  React.useEffect(()=> {
    if(recipe === undefined) {
      fetchSuite()
    }
  }, [id])
  
  async function fetchSuite() {
    try { 
      const response = await fetch(`https://api.menubook.ru/recipe/${id}/project`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
      });
      if(!response.ok) {
        throw new Error('Server Error!')
      }
      const data = await response.json();
      setRecipeSerch(data) 
    } catch (error) {
      console.log(error)  
    } finally {
    
    }
  }

  function handleReplace() {
    if(!props.blockedSaveMenu) {
      setClick(true)
      props.autoReplace(recipe, props.mealsEn, props.mealsRu)
    } else {
      props.blockedSaveMenus('blockedUpdateMenu')
    } 
  }

  function handleEdite() {
    if(!props.blockedSaveMenu) {
      setClick(true)
      props.handleEdite(id, props.mealsEn, props.mealsRu)
    } else {
      props.blockedSaveMenus('blockedUpdateMenu')
    } 
  }

  function handleDeleteRecipe() {
    if(!props.blockedSaveMenu) {
      setClick(true)
      props.handleDeleteRecipe(id, props.mealsEn)
    } else {
      props.blockedSaveMenus('blockedUpdateMenu')
    } 
  }
  
  return (
    <>
    {(recipe || recipeSerch) &&
    <div className='menu-dish'> 
      { (click || props.click || props.clickCreate) && statusPlan === 'loading'? 
        <Preloader type='menu'/>
       : <img  className='menu-dish__image' src={recipe ? recipe.image[0] : recipeSerch.image[0]}/> 
      }
      <div className='menu-dish__info'> 
        <Link className='menu-dish__title font16N' target="_blank"  to={`/recipes/${id}`}>{recipe ? recipe.name: recipeSerch.name}</Link>
        <div className='menu-dish__icons_rows'>
          <button  className='gg-replace m-size' onClick={handleReplace}/>
          <button onClick={handleEdite} className='gg-edit m-size'/>
          <p className='menu-dish__cal'>{Math.ceil(recipe? recipe.calories.calories/recipe.servings: recipeSerch.calories.calories/recipeSerch.servings)} ккал</p>
        </div>
       
      </div>
      
      <button onClick={handleDeleteRecipe} className='menu-dish__delete gg-delete m-size' />
    </div>
    }
  </>
  )
}